export default "__VITE_ASSET__ad8bc147__"